import cls from 'classnames'
import { Svg } from 'components/ui'
import SurveyContext from 'contexts/survey-context'
import { h } from 'preact'
import { useContext, useState } from 'preact/hooks'
import useFitImageDimensions from 'scripts/hooks/useFitImageDimensions'
import { Image } from 'scripts/type'

import classes from './fieldImage.scss'

type Props = {
  image?: Image
}

const FieldImage = ({ image }: Props) => {
  const [loaded, setLoaded] = useState(false)
  const { wrapperMaxWidth } = useContext(SurveyContext)
  const { width, height } = useFitImageDimensions({
    width: image?.width ?? 0,
    height: image?.height ?? 0,
    maxWidth: wrapperMaxWidth,
  })

  if (!image) {
    return null
  }

  const handleOnLoad = () => {
    setLoaded(true)
  }

  return (
    <div className={classes.fieldImage}>
      <div
        className={classes.imageWrapper}
        style={{
          width,
          height,
        }}
      >
        <img src={image.url} width={width} height={height} className={classes.image} alt="" onLoad={handleOnLoad} />
      </div>
      <div
        className={cls(classes.loading, {
          [classes.loadingLoaded]: loaded,
        })}
      >
        <Svg.Picture />
      </div>
    </div>
  )
}

export default FieldImage
